const STORAGE_KEY = 'tesla-videoplayer.autoplay';
export const AUTOPLAY_DELAY_MS = 3000;

export interface AutoplayDom {
  readonly toggle: HTMLButtonElement;
  readonly card: HTMLElement;
  readonly title: HTMLElement;
  readonly bar: HTMLElement;
  readonly playNow: HTMLButtonElement;
  readonly cancel: HTMLButtonElement;
}

function readSetting(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'off';
  } catch {
    return true;
  }
}

function writeSetting(on: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, on ? 'on' : 'off');
  } catch {
    return;
  }
}

export class Autoplay {
  private on = readSetting();
  private timer = 0;
  private advance: (() => void) | undefined;

  constructor(private readonly dom: AutoplayDom) {
    dom.toggle.addEventListener('click', () => this.toggle());
    dom.playNow.addEventListener('click', () => this.fire());
    dom.cancel.addEventListener('click', () => this.cancel());
    this.render();
  }

  get enabled(): boolean {
    return this.on;
  }

  get counting(): boolean {
    return this.advance !== undefined;
  }

  toggle(): void {
    this.on = !this.on;
    writeSetting(this.on);
    if (!this.on) this.cancel();
    this.render();
  }

  offer(title: string, advance: () => void): void {
    if (!this.on) return;
    this.cancel();
    this.advance = advance;
    this.dom.title.textContent = title;
    this.dom.card.hidden = false;
    this.dom.bar.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: AUTOPLAY_DELAY_MS, easing: 'linear', fill: 'forwards' });
    this.timer = window.setTimeout(() => this.fire(), AUTOPLAY_DELAY_MS);
  }

  fire(): void {
    const advance = this.advance;
    this.cancel();
    advance?.();
  }

  cancel(): void {
    window.clearTimeout(this.timer);
    this.advance = undefined;
    this.dom.card.hidden = true;
  }

  private render(): void {
    this.dom.toggle.setAttribute('aria-checked', String(this.on));
    this.dom.toggle.title = this.on ? 'Autoplay is on: the next recording starts 3 s after this one ends (A)' : 'Autoplay is off (A)';
  }
}
